<template>
  <div>
    <section class="opacidade-inicio">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img
            class="d-block w-100 img-carousel"
            src="../assets/images/mesa-trabalho.jpg"
            alt="Mesa de Trabalho"
          />
          <div class="carousel-caption">
            <h4 class="font-weight-bold">
              Esta na hora de terceirizar a contabilidade da sua empresa?
            </h4>
            <form action="https://forms.gle/XuBc2JdF7tf3uqYq7" target="_blank">
              <input
                type="submit"
                class="btn btn-outline-light"
                value="Faça o Teste!"
              />
            </form>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="bg-blue" style="height: 15vh"></div>
    </section>

    <section class="vw-100">
      <div class="container px-5">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="container">
              <div class="text-center">
                <h3>Quem Somos</h3>
              </div>
            </div>
            <div class="pb-3">
              <div class="text-center m-3 row justify-content-center">
                <div class="col-md-5">
                  <img
                    src="../assets/images/entrada.jpeg"
                    class="rounded img-fluid"
                    alt="Entrada Skala"
                  />
                </div>
              </div>
              <p class="text-center">
                Conheça nossa história e sinta-se convidado a fazer parte dela.
                A Skala percorre uma trajetória pelo atendimento pleno às
                necessidades dos empreendedores e suas empresas. O
                aperfeiçoamento contínuo, pautado pela ética, garante a
                satisfação dos clientes de 1990 até os dias atuais. Juntos
                transformamos vidas, trabalhamos com propósito e paixão. Venha
                conhecer mais sobre nossa história, forma de pensar e agir.
                <a href="https://youtu.be/vFmWX42mY2M" target="_blank">Clique aqui</a> e saiba mais!
              </p>
              <div class="row text-center">
                <div class="col-md-4">
                  <img
                    src="../assets/images/missao.jpg"
                    class="rounded pb-4"
                    alt="Sobre Nós"
                  /><br />
                  <h3>Missão</h3>
                  <p>
                    Desenvolver negócios com integridade, apresentando soluções
                    claras e objetivas, que ofereçam benefícios perceptíveis aos
                    nossos clientes.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="../assets/images/visao.jpg"
                    class="rounded pb-4"
                    alt="Sobre Nós"
                  /><br />
                  <h3>Visão</h3>
                  <p>
                    Ser uma empresa reconhecida por prover soluções inovadoras
                    aos nossos clientes, por meio do desenvolvimento humano.
                  </p>
                </div>
                <div class="col-md-4">
                  <img
                    src="../assets/images/valores.jpg"
                    class="rounded pb-4"
                    alt="Sobre Nós"
                  /><br />
                  <h3>Valores</h3>
                  <p>
                    Qualidade e satisfação na entrega dos serviços;
                    <br />
                    Formação e desenvolvimento humano;
                    <br />
                    Credibilidade e transparência;
                    <br />
                    Integridade acima de tudo.
                  </p>
                </div>
              </div>
              <h5 class="text-center font-weight-bold">
                Sabemos que todos os contadores dizem que são altamente
                qualificados, profissionais e focados no cliente, então nem
                vamos mencionar isso. Afinal, essa é apenas uma expectativa
                básica, certo? Fale com os contadores Skala.
              </h5>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="bg-blue" style="height: 15vh"></div>
    </section>

    <section class="vw-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="container">
              <div class="text-center">
                <h3>Serviços</h3>
              </div>
            </div>
            <div class="pb-3">
              <div class="row justify-content-center text-center text-md-left">
                <div class="col-md-2 text-center">
                  <img
                    src="../assets/images/tax-day.jpg"
                    class="rounded-circle"
                    width="150"
                    alt="Tax Day"
                  />
                </div>
                <div class="col-md-8">
                  <h4>Legalização</h4>
                  <p>
                    Abertura, regularização e assessoria, tudo que o novo
                    empreendedor precisa para seu negócio, ele encontra aqui
                  </p>
                </div>
              </div>
              <div
                class="
                  row
                  justify-content-center
                  flex-row-reverse
                  text-md-right text-center
                "
              >
                <div class="col-md-2 text-center">
                  <img
                    src="../assets/images/coins.jpg"
                    class="rounded-circle"
                    width="150"
                    alt="Moedas"
                  />
                </div>

                <div class="col-md-8">
                  <h4>Contabilidade</h4>
                  <p>
                    Folha de Pagamento, Apuração de Impostos, Diário Geral,
                    Razão Analítico, Balanço Patrimonial, Demonstração do
                    Resultado do Exercício, Declarações (RAIS, Pessoa Jurídica,
                    entre outras)
                  </p>
                </div>
              </div>

              <div class="row justify-content-center text-md-left text-center">
                <div class="col-md-2 text-center">
                  <img
                    src="../assets/images/graphic.jpg"
                    class="rounded-circle"
                    width="150"
                    alt="Gráfico"
                  />
                </div>
                <div class="col-md-8">
                  <h4>Assessorias</h4>
                  <p>
                    Estabeleça metas alinhadas aos recursos disponíveis da
                    empresa e faça uma gestão de forma mais tranquila afim de
                    tomar as melhores decisões na redução das despesas ou na
                    negociação de novos investimentos com assessoria: Contábil,
                    Financeira e Tributária.
                  </p>
                </div>
              </div>
            </div>
            <div class="text-center">
              <v-btn
                color="blue"
                outlined
                text
                v-on:click="vejaMais('servicos')"
              >
                Saiba Mais
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="bg-blue" style="height: 15vh"></div>
    </section>

    <section class="vw-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="container">
              <div class="text-center pb-3 pt-4">
                <h3>Contatos</h3>
              </div>
            </div>
            <div class="row pb-5">
              <div class="col-md-10 text-right">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.917369300668!2d-46.6967630489197!3d-23.499485584638624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cef8492c6ec671%3A0xc19713a624bca7b4!2sR.%20Bonif%C3%A1cio%20Cubas%2C%20389%20-%20Vila%20Albertina%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2002731-000!5e0!3m2!1spt-BR!2sbr!4v1593991707269!5m2!1spt-BR!2sbr"
                  width="100%"
                  height="450"
                  frameborder="0"
                  style="border: 0"
                  allowfullscreen=""
                  aria-hidden="false"
                  tabindex="0"
                ></iframe>
              </div>
              <div class="col-md-2 text-center text-md-left">
                <h3>Skala</h3>
                <h5>Endereço</h5>
                <p>Rua Bonifácio Cubas, 389</p>
                <p>Freguesia do Ó</p>
                <p>São Paulo</p>
                <h5>Telefone</h5>
                <p>(11) 3854-5377</p>
                <p>(11) 3921-2345</p>
                <h5>E-mail</h5>
                <p>contato@skalanet.com.br</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
/* eslint-disable */
import router from "../router";
export default {
  data() {
    return {
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        },
      ],
    };
  },
  methods: {
    vejaMais(rota) {
      router.push({ path: `/${rota}` }).catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Inicio.vue